import {h} from 'ui/Framework';

export default h('svg', {
  width: '30',
  height: '30',
  viewBox: '-1 -1 32 32',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', [
      h('g', [
        h('rect', {
          stroke: '#21304A',
          fill: 'none',
          width: '30',
          height: '30',
          rx: '5'
        }),
        h('path', {
          d: 'M6 14.512c.32 0 .597-.112.832-.336.235-.224.352-.592.352-1.104v-3.008c0-.363.05-.675.152-.936.101-.261.24-.477.416-.648.176-.17.379-.293.608-.368.23-.075.467-.112.712-.112h1.088v1.104h-.816a.785.785 0 0 0-.432.104.656.656 0 0 0-.24.272c-.053.112-.09.235-.112.368-.021.133-.032.27-.032.408v2.928c0 .352-.056.645-.168.88a1.787 1.787 0 0 1-.904.896c-.17.075-.31.117-.416.128v.032c.107.01.245.048.416.112.17.064.336.168.496.312.16.144.296.339.408.584.112.245.168.56.168.944v2.88c0 .139.01.275.032.408.021.133.059.256.112.368a.656.656 0 0 0 .24.272c.107.07.25.104.432.104h.816v1.104H9.072c-.245 0-.483-.037-.712-.112a1.555 1.555 0 0 1-.608-.368 1.799 1.799 0 0 1-.416-.64c-.101-.256-.152-.57-.152-.944V17.2c0-.544-.117-.93-.352-1.16A1.15 1.15 0 0 0 6 15.696v-1.184zm8.112 4.24c0 .277-.101.523-.304.736-.203.213-.459.32-.768.32-.299 0-.552-.104-.76-.312a.998.998 0 0 1-.312-.728c0-.288.101-.536.304-.744.203-.208.459-.312.768-.312.31 0 .565.101.768.304.203.203.304.448.304.736zm4.16 0c0 .277-.101.523-.304.736-.203.213-.459.32-.768.32-.299 0-.552-.104-.76-.312a.998.998 0 0 1-.312-.728c0-.288.101-.536.304-.744.203-.208.459-.312.768-.312.31 0 .565.101.768.304.203.203.304.448.304.736zm5.968-3.056c-.32 0-.597.115-.832.344-.235.23-.352.616-.352 1.16v2.944c0 .373-.05.688-.152.944-.101.256-.24.47-.416.64-.176.17-.379.293-.608.368-.23.075-.467.112-.712.112H20.08v-1.104h.832c.17 0 .31-.035.416-.104a.656.656 0 0 0 .24-.272c.053-.112.09-.235.112-.368.021-.133.032-.27.032-.408v-2.88c0-.384.056-.699.168-.944a1.75 1.75 0 0 1 .408-.584 1.57 1.57 0 0 1 .496-.312c.17-.064.315-.101.432-.112v-.032a1.454 1.454 0 0 1-.432-.128 1.787 1.787 0 0 1-.904-.896c-.112-.235-.168-.528-.168-.88v-2.928c0-.139-.01-.275-.032-.408a1.346 1.346 0 0 0-.112-.368.656.656 0 0 0-.24-.272.751.751 0 0 0-.416-.104h-.832V8h1.088c.245 0 .483.037.712.112.23.075.432.197.608.368.176.17.315.387.416.648.101.261.152.573.152.936v3.008c0 .512.117.88.352 1.104.235.224.512.336.832.336v1.184z',
          fill: '#000'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-json-small.es6.js